import {groupBy, sortBy, concat} from 'lodash'
import {mapGetters} from 'vuex';
import constants from '@/libs/constant/constants'
import { getAllFollowingList, getMetaDataList} from '@/libs/api/api'
import {errorHandler, message, logout, loader, getImageUrl, onError} from '@/libs/helper'
import AlphabeticalList from '@/components/component/AlphabeticalList/AlphabeticalList.vue'

export default{
    props: {
        module: {
            type: String,
            required: true,
            default: () => ''
        },
        displayList: {
            type: String,
            required: false,
            default: () => "true"
        },
        isShow: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        toSearch: {
            type: String,
            default: 'All'
        }
    },
    components: {
        AlphabeticalList
    },
    computed: {
        ...mapGetters({
            userInformation: 'getUserInformation'
        })
    },
    mounted: async function () {
        this.setQuerySearch()
        if(this.module === 'ALL') return

        let isListAvailable = this.$store.getters.getUserFollowings.isListAvailable

        if(isListAvailable){
            let result = this.$store.getters.getUserFollowings[this.module.toLowerCase()]
            if(this.module === constants.AUTHOR.key){
                let registeredAuthor = this.$store.getters.getRegisteredAuthor
                if(result.length >= registeredAuthor.length){
                    this.generateGroupedList(result)
                    return
                }
            }else if(this.module === constants.PUBLICATION.key){
                let registeredPublication = this.$store.getters.getRegisteredPublication
                if(result.length >= registeredPublication.length){
                    this.generateGroupedList(result)
                    return
                }
            }else if(this.module === constants.PUBLISHER.key){
                let registeredPublisher = this.$store.getters.getRegisteredPublisher
                if(result.length >= registeredPublisher.length){
                    this.generateGroupedList(result)
                    return
                }
            }
        }

        let result = []

        let body = {
            is_global: false
        }

        try{
            loader(this, true)
            result = await this.searchFollowers(body, this.module.toLowerCase())
            loader(this, false)
            this.generateGroupedList(result[this.module.toUpperCase()])
        }catch(error){
            message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
        }
    },
    data(){
        return {
            groupedList: {},
            length: 0,
            availableAlphabetsAndNumbers: [],
            searchFor: 'ALL',
            searchInput: '',
            getImageUrl: getImageUrl,
            onError: onError
        }
    },
    watch: {
        toSearch (value) {
            if (value !== '' && value !== null) {
                this.searchFor = constants[value].route 
            }
            
        }
    },
    methods:{
        generateGroupedList(listToGroup){
            this.groupedList = this.module === 'AUTHOR' ?
                groupBy(sortBy(listToGroup, 'last_name'), (x)=> x.last_name.charAt(0).toLowerCase()) :
                groupBy(sortBy(listToGroup, 'name'), (x)=> x.name.charAt(0).toLowerCase())
            this.availableAlphabetsAndNumbers = sortBy(Object.keys(this.groupedList))
            // let objectLength = this.availableAlphabetsAndNumbers.length
            // if(objectLength % 2 === 0 ){
            //     this.length = objectLength / 2
            // } else {
            //     this.length = (objectLength + 1) / 2
            // }
        },
        searchOn(search){
            if(!this.availableAlphabetsAndNumbers.includes(search.toLowerCase())) return

            document.getElementById(search).scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        },
        querySearch: async function (queryString, cb) {
            if(queryString === undefined || queryString === '' || queryString.length < 2){
                return
            }

            let searchResult = []
            let body = {
                search_name: queryString,
                is_global: true
            }
            if (this.isAdmin) {
                body = {
                    search_text: queryString,
                    type: constants.ADMIN[this.searchFor].value_without_s
                }
            }
            try{
                let param = constants.ADMIN[this.searchFor].value_without_s
                searchResult = await this.searchFollowers(body, param.toLowerCase())
            }catch(error){
                return error
            }

            let listToDisplay = concat(searchResult.AUTHOR || [],searchResult.PUBLICATION || [], searchResult.PUBLISHER || [], searchResult.ARTICLE || [], searchResult.USER || [])

            // call callback function to return suggestion objects
            cb(listToDisplay);
        },
        /**
         * API call to fetch theauthor, publication, publisher by text/string.
         * @params {object} body to send in the API call
         * @params {object} params to add with the API URL
         */
        searchFollowers (body, params) {
            if (this.isAdmin) {
                return getMetaDataList(body).then(response => {
                    let result = {
                        AUTHOR: response['AUTHORS'],
                        PUBLISHER: response['PUBLISHERS'],
                        PUBLICATION: response['PUBLICATIONS'],
                        ARTICLE: response['ARTICLES'],
                        USER: response['USERS']
                    } 
                    return result
                }).catch(error => error)
            }
            return getAllFollowingList(body, params).then((response) => {
                return response.items
            }).catch((error) => {
                return error
            })
        },
        routeToDetailPage(record){
            if(this.isAdmin) {
                this.$router.push({name: `edit${constants[record.type].route}`, params: {id: record._id}})
                return
            }
            this.$router.push(`${record.type.toLowerCase()}s/${record._id}/`)
        },
        change(){
        },
        setQuerySearch () {
            let route = this.$route
            if (!this.isAdmin && route && (route.name === 'publications') || route.path.includes('/publication')) {
                this.searchFor = 'Publications'
            } else if (!this.isAdmin && route && (route.name === 'authors' || route.path.includes('/author'))) {
                this.searchFor = 'Authors'
            } else if (!this.isAdmin && route && (route.name === 'publishers') || route.path.includes('/publisher')) {
                this.searchFor = 'Publishers'
            } else {
                this.searchFor = 'ALL'
            }
        }
    }
}